import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import events from '@/constants/websocketEvents';

const useWebSocket = (event, callback) => {
    const socket = useRef(null);

    useEffect(() => {
        const apiUrl = import.meta.env.VITE_API_URL;
        const isLocal = apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1');
        const socketUrl = apiUrl.startsWith('https') ? apiUrl.replace(/^https/, 'wss') : apiUrl.replace(/^http/, 'ws'); // Remplace http par ws pour le WebSocket

        socket.current = io(socketUrl, {
            secure: !isLocal, // Utilise secure seulement si ce n'est pas local
            transports: ['websocket'],
            withCredentials: true, // Important for CORS with credentials
            path: '/socket.io/', // Ensure this matches your backend route
        });

        // socket.current.on('connect', () => {
        //     console.log('Connecté au serveur Socket.io');
        // });

        // socket.current.on('disconnect', () => {
        //     console.log('Déconnecté du serveur Socket.io');
        // });

        // Écouter l'événement spécifié
        if (events[event] && event && callback) {            
            socket.current.on(event, (incomingData) => {
                callback(incomingData);
            });
        }

        return () => {
            if (socket.current) {
                socket.current.disconnect();
            }
        };
    }, [callback]);

    return {};
};

export default useWebSocket;